import React from "react";

const ClockIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_26692_124691)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.0026 1.83594C4.59685 1.83594 1.83594 4.59685 1.83594 8.0026C1.83594 11.4084 4.59685 14.1693 8.0026 14.1693C8.27155 14.1693 8.53623 14.1521 8.79567 14.1188C9.06957 14.0837 9.32009 14.2772 9.35523 14.5511C9.39037 14.825 9.19681 15.0755 8.92291 15.1107C8.62139 15.1494 8.3142 15.1693 8.0026 15.1693C4.04456 15.1693 0.835938 11.9606 0.835938 8.0026C0.835938 4.04456 4.04456 0.835938 8.0026 0.835938C11.9606 0.835938 15.1693 4.04456 15.1693 8.0026C15.1693 8.30925 15.15 8.61163 15.1125 8.90855C15.0779 9.18252 14.8278 9.37658 14.5538 9.34199C14.2799 9.30741 14.0858 9.05728 14.1204 8.78331C14.1526 8.52783 14.1693 8.26728 14.1693 8.0026C14.1693 4.59685 11.4084 1.83594 8.0026 1.83594ZM8.0026 3.5026C8.27875 3.5026 8.5026 3.72646 8.5026 4.0026V7.69359L10.7185 8.80152C10.9654 8.92501 11.0656 9.22535 10.9421 9.47234C10.8186 9.71933 10.5182 9.81944 10.2712 9.69594L7.779 8.44982C7.60961 8.36512 7.5026 8.19199 7.5026 8.0026V4.0026C7.5026 3.72646 7.72646 3.5026 8.0026 3.5026ZM12.6693 9.5026C12.9454 9.5026 13.1693 9.72646 13.1693 10.0026V12.6693C13.1693 12.9454 12.9454 13.1693 12.6693 13.1693C12.3931 13.1693 12.1693 12.9454 12.1693 12.6693V10.0026C12.1693 9.72646 12.3931 9.5026 12.6693 9.5026ZM12.1693 14.6693C12.1693 14.3931 12.3931 14.1693 12.6693 14.1693H12.6759C12.9521 14.1693 13.1759 14.3931 13.1759 14.6693C13.1759 14.9454 12.9521 15.1693 12.6759 15.1693H12.6693C12.3931 15.1693 12.1693 14.9454 12.1693 14.6693Z"
          fill="#6E00BE"
        />
      </g>
      <defs>
        <clipPath id="clip0_26692_124691">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
